import {set} from "vue";

const state = {
    default: {
        loading: 0,
        timer: null
    }
}

const getters = {
    activity: (state) => !!state.default.loading,
    activity_alt: (state) => (which, isolated) => {
        if (state[which] && state[which].loading)
            return isolated || !state.default.loading
        else
            return false
    }
}

const mutations = {
    activity_loading(state, which) {
        which = which || 'default'
        console.log('active loading', which)
        if (!state[which])
            set(state, which, {loading: 0, timer: null})

        if (state[which].timer) {
            clearTimeout(state[which].timer)
            state[which].timer = null
            return
        }
        state[which].loading += 1
    },
    activity_done(state, which) {
        which = which || 'default'
        console.log('active done', which)
        if (!state[which])
            set(state, which, {loading: 0, timer: null})

        if (state[which].loading === 1) {
            state[which].timer = setTimeout(() => {
                state[which].timer = null
                state[which].loading -= 1
            }, 750)
            return
        }
        state[which].loading -= 1
    }
}

export default {
    state,
    mutations,
    getters,
}